<template>
  <div class="mast-head">
    <v-row>
      <v-col cols="2">
        <img class="pa-md-4" width="110px" alt="PDC" src="@/assets/pdc_logo.png">
      </v-col>
      <v-col cols="4">
        <div class="contact-information">
          <div>
            711 Capitol Way Suite 206 <br/>
            PO Box 40908 Olympia, WA 98504-0908<br/>
          </div>
          (360) 753-1111<br/>
          Toll Free 1-800-601-2828
        </div>
      </v-col>
      <v-col cols="4">
        <h3>{{ title }}</h3>
      </v-col>
      <v-col cols="2">
        <h1 class="text-uppercase">{{ report_type }}</h1>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "Masthead",
  props: {
    title: {
      type: String,
      default: ''
    },
    report_type: String
  }
}
</script>

<style>

.mast-head {
  padding-bottom: 5px;
}

div.contact-information {
  line-height: 1.2em;
}

.mast-head .contact-information {
  display: inline-block;
  font-size: .8em;
}

.mast-head h3 {
  font-size: .9em;
}

/** block styling section */
.v-application {
  line-height: 1.0 !important;
}

.schedule {
  padding-top: 5px;
  border-top: solid 2px;
  page-break-before: always;
}

.report-section {
  display: block;
  margin: 5px 0;
}

/** end block styling section */

/** text styling section */

.noReport {
  /* needed because the display is outside the table */
  padding: 5px 16px;
}

#report, #report td {
  font-size: .9em;
  font-family: Roboto, sans-serif;
}

h3.line-item-title {
  font-size: 1.0em;
  font-weight: normal;
  text-transform: uppercase;
  margin-bottom: 0.5em;
}

.small-text {
  font-size: .7em;
}

.v-divider {
  padding-bottom: 1em;
}

/* end text styling section */

/** table styling **/
.formTitle {
  font-weight: bold;
  font-size: 1.2em;
  padding-bottom: 5px;
}

#report table tbody tr td {
  height: 1.3em !important;
}

#report th.amountColumn, #report td.amountColumn {
  text-align: right;
}

#report table td {
  vertical-align: top;
}

th.dateColumn, th.typeColumn {
  width: 10em;
}

th.paddedColumn, td.paddedColumn {
  padding-left: 1%;
}

.indented-text {
  padding-left: 1.5em;
}

.newspaperColumnLayout {
  margin: 5px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  border-right: 1px solid black;
}

.newspaper-cols-container {
  display: flex;
}

/** end table styling **/

/** print media styling */
@media print {
  .container {
    padding: 0;
  }

  .mast-head {
    display: block;
  }

  .schedule {
    border-top: none;
  }

  .avoid-break {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .registrationLink {
    visibility: hidden;
  }
}

/** end print media styling */

</style>